import { createSlice } from "@reduxjs/toolkit";

// project imports
import axios from "utils/axios";
import { dispatch } from "../index";

// initial state
const initialState = {
  isLoading: false,
  businessConfig: {
    refresh_time: 1672196504,
    first_pay: false
  }
};

// ==============================|| SLICE - global ||============================== //

const global = createSlice({
  name: "global",
  initialState,
  reducers: {
    setLoading(state, action) {
      state.isLoading = action.payload;
    },
    getBusinessConfigSuccess(state, action) {
      state.businessConfig = action.payload;
    }
  }
});

export default global.reducer;

export const { setLoading } = global.actions;

export interface BusinessConfig {
  refresh_time: number;
  first_pay: boolean;
}
